export default __webpack_public_path__ + "static/media/notification-1733830000648.07ffba0a.png";